// removed by extract-text-webpack-plugin
module.exports = {"label":"jx_g8","stars":"jx_ei","small":"jx_jy"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/StarRating/components/StarRating/styles.module.css
// module id = 1103
// module chunks = 27